import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { LegacyButton } from '@/components/LegacyButton';

export const Heros = styled.div`
  display: flex;
  margin-top: 20px;
  height: 398px;

  @media (min-width: 1024px) {
    width: 38.7%;
    margin-top: 0;
    height: auto;
  }
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.secondaryLightGrey};
  margin-right: 0;
  max-height: none;

  @media (min-width: 1024px) {
    flex-direction: row;
    width: 58.9%;
    max-height: 594px;
    flex-shrink: 0;
    flex-grow: 0;
  }
`;

export const Image = styled(Box)`
  width: 100%;
  overflow: hidden;
  @media (min-width: 1024px) {
    width: 50%;
  }
`;

export const Text = styled(Box)<{ $isExpanded: boolean }>`
  display: none;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    line-height: ${theme.lineHeights.h5Mobile};
  `}

  @media (min-width: 1024px) {
    @supports (-webkit-line-clamp: 10) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      display: -webkit-box;
      ${({ $isExpanded }) => css`
        -webkit-line-clamp: ${$isExpanded ? 'none' : '10'};
      `}
      -webkit-box-orient: vertical;
    }
  }
  @media (max-width: 1400px) {
    font-size: 0.75em;
  }
`;

export const SeeMoreButton = styled.span<{ $display: boolean }>`
  ${({ $display, theme }) => css`
    font-size: ${theme.fontSizes.p2};
    line-height: ${theme.lineHeights.h5Mobile};
    text-decoration: underline;
    cursor: pointer;
    display: ${$display ? 'block' : 'none'};
  `}
`;

export const BannerTextBox = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  @media (min-width: 1024px) {
    width: 50%;
  }
`;

export const StyledLink = styled(LegacyButton)`
  font-weight: bold;
  ${({ theme }) => css`
    color: ${theme.colors.primaryDark};
    margin-top: ${theme.spacing(2)};
  `}}
`;
